import { forwardRef } from 'react';

interface PageProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  className?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(function Page(
  { children, title = '', subtitle, className = '', ...other },
  ref
) {
  return (
    <div ref={ref} className={className} {...other}>
      {title ? (
        <header className="mb-6 border-b border-slate-200/80 pb-4">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          {subtitle !== undefined ? (
            <p className="mt-1 text-sm text-slate-500">{subtitle}</p>
          ) : null}
        </header>
      ) : null}
      {children}
    </div>
  );
});

export default Page;
